<template>
    <div class="flex flex-col">
        <div class="flex justify-end gap-x-3">
            <button @click="$emit('cancel')"
                class="inline-flex items-center px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-100 transition duration-150">
                <font-awesome-icon :icon="['fas', 'ban']" class="text-red-500 mr-2" />
                Cancel
            </button>
            <button @click="save"
                class="inline-flex items-center px-5 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition duration-150">
                <font-awesome-icon :icon="['fas', 'save']" class="mr-2" />
                Save
            </button>
        </div>
        <div ref="printSection" v-if="mouEffectivenessCard" class="mt-6 w-full mx-auto box-border"
            style="min-width: 210mm;">
            <table class="w-full border border-black border-collapse">
                <tbody>
                    <tr>
                        <th colspan="3" class="font-bold text-center t-heading text-black p-3 border border-black">
                            <div class="flex flex-col">
                                <div>بطاقة فعالية مذكرة التفاهم</div>
                                <div>MoU Effectiveness Card</div>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">First Party</th>
                        <td class="bg-white p-2 border border-black">
                            <multiselect v-model="form.first_party.val" :options="entities" :multiple="true"
                                :custom-label="customLabel" placeholder="Select an entity">
                            </multiselect>
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">الطرف
                            الأول
                        </th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">Second Party</th>
                        <td class="bg-white p-2 border border-black">
                            <input v-model="form.second_party.val" type="text" placeholder="Second Party"
                                class="w-full border-none outline-none" />
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">الطرف
                            الثاني</th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">Concerned
                            Department
                        </th>
                        <td class="bg-white p-2 border border-black">
                            <input v-model="form.concerned_department.val" type="text"
                                placeholder="Concerned Department" class="w-full border-none outline-none" />
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">الإدارة
                            المعنية</th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">MOU Signing Date
                        </th>
                        <td class="bg-white p-2 border border-black">
                            <input v-model="form.mou_signing_date.val" type="date" placeholder="MOU Signing Date"
                                class="w-full border-none outline-none" />
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">تاريخ
                            توقيع
                            المذكرة</th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">MOU End Date</th>
                        <td class="bg-white p-2 border border-black">
                            <input v-model="form.mou_end_date.val" type="date" placeholder="MOU End Date"
                                class="w-full border-none outline-none" />
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">تاريخ
                            انتهاء المذكرة</th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>Departments/Sections</div>
                                <div>Involved in Implementing</div>
                                <div>MOU clauses</div>
                            </div>
                        </th>
                        <td class="bg-white p-2 border border-black">
                            <textarea v-model="form.mou_clauses.val"
                                placeholder="Departments/Sections Involved in Implementing MOU clauses"
                                class="w-full border-none outline-none resize-none"></textarea>
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>الإدارات / الأقسام المشاركة</div>
                                <div>في تنفيذ بنود المذكرة</div>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th class="t-column p-2 text-black border border-black whitespace-nowrap">Coordinators Name
                        </th>
                        <td class="bg-white border-0 p-0">
                            <table class="w-full border-0 border-collapse m-0">
                                <thead>
                                    <tr class="border-b border-black">
                                        <th class="t-column p-1 text-center border-r border-black whitespace-nowrap">
                                            <div class="flex flex-col">
                                                <div>الطرف الثاني</div>
                                                <div>Second Party</div>
                                            </div>
                                        </th>
                                        <th class="t-column p-1 text-center whitespace-nowrap">
                                            <div class="flex flex-col">
                                                <div>الطرف الأول</div>
                                                <div>First Party</div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center">
                                        <td class="p-1 border-r border-black">
                                            <input v-model="form.coordinator_second_party.val" type="text"
                                                placeholder="Second Party" class="w-full border-none outline-none" />
                                        </td>
                                        <td class="p-1">
                                            <input v-model="form.coordinator_first_party.val" type="text"
                                                placeholder="First Party" class="w-full border-none outline-none" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">أسماء
                            المنسقين</th>
                    </tr>
                </tbody>
            </table>
            <table class="mt-8 w-full border border-black border-collapse">
                <thead>
                    <tr>
                        <th colspan="6" class="font-bold text-center t-heading text-black p-3 border border-black">
                            <div class="flex flex-col">
                                <div>اجتماعات اللجنة المشتركة</div>
                                <div>Joint Committee Meetings</div>
                            </div>
                        </th>
                    </tr>
                    <tr class="border-b border-black">
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>سنة</div>
                                <div>Year</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>الربع الرابع</div>
                                <div>Q4</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>الربع الثالث</div>
                                <div>Q3</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>الربع الثاني</div>
                                <div>Q2</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>الربع الأول</div>
                                <div>Q1</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>Actions</div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in form.mouJointCommitteeMeetings.val" :key="index" class="text-center">
                        <td class="p-1 border border-black">
                            <input v-model="item.year" type="text" inputmode="numeric" maxlength="4" placeholder="Year"
                                class="w-full border-none outline-none" @input="handleYearInput($event, item)" />
                        </td>
                        <td class="p-1 border border-black text-left">
                            <input v-model="item.q4" type="text" placeholder="Q4"
                                class="w-full border-none outline-none" />
                        </td>
                        <td class="p-1 border border-black text-left">
                            <input v-model="item.q3" type="text" placeholder="Q3"
                                class="w-full border-none outline-none" />
                        </td>
                        <td class="p-1 border border-black text-left">
                            <input v-model="item.q2" type="text" placeholder="Q2"
                                class="w-full border-none outline-none" />
                        </td>
                        <td class="p-1 border border-black text-left">
                            <input v-model="item.q1" type="text" placeholder="Q1"
                                class="w-full border-none outline-none" />
                        </td>
                        <td class="p-1 border border-black">
                            <button @click="form.mouJointCommitteeMeetings.val.splice(index, 1)"
                                class="text-red-600 hover:text-red-800 transition" title="Remove">
                                <font-awesome-icon :icon="['fas', 'trash']" />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="flex justify-end mt-2">
                <button @click="addCommitteeMeetingRow"
                    class="inline-flex items-center px-3 py-1 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded shadow-sm transition duration-150">
                    <font-awesome-icon :icon="['fas', 'plus']" class="mr-2" />
                    Add Row
                </button>
            </div>
            <table class="mt-8 w-full border border-black border-collapse">
                <thead>
                    <tr>
                        <th colspan="4" class="font-bold text-center t-heading text-black p-3 border border-black">
                            <div class="flex flex-col">
                                <div>المخرجات الرئيسية لمذكره التفاهم</div>
                                <div>Main Outcomes for MOU</div>
                            </div>
                        </th>
                    </tr>
                    <tr class="border-b border-black">
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>% الفعلي إلى المتوقع</div>
                                <div>Actual to Expected %</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>الفعلي</div>
                                <div>Actual</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>المتوقع</div>
                                <div>Expected</div>
                            </div>
                        </th>
                        <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                            <div class="flex flex-col">
                                <div>المخرجات الرئيسية</div>
                                <div>Main Outcomes</div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in form.moUOutcomes.val" :key="index" class="text-center">
                        <td class="p-1 border border-black">{{ getPercentage(item.actual, item.expected) }}</td>
                        <td class="p-1 border border-black">
                            <input v-model="item.actual" type="number" min="0" placeholder=""
                                class="w-full border-none outline-none" />
                        </td>
                        <td class="p-1 border border-black"><input v-model="item.expected" type="number" min="0"
                                placeholder="" class="w-full border-none outline-none" />
                        </td>
                        <td class="p-1 border border-black">
                            <div class="flex flex-col">
                                <div>{{ getArabicText(item.name) }}</div>
                                <div>{{ item.name }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
export default {
    name: "mou-effectiveness-card-edit",
    components: {
        Multiselect
    },
    props: ["mouEffectivenessCard", "mode"],
    data() {
        return {
            entities: ["FCHS", "ADPOLY", "ATS", "ADVETI", "IAT"],
            form: null,
        };
    },
    created() {
        this.setData();
    },
    methods: {
        customLabel(option) {
            return option;
        },
        setData() {
            const dummyMoUOutcomes = [
                {
                    "name": "Graduates Employment",
                    "actual": null,
                    "expected": null
                },
                {
                    "name": "Training while studying",
                    "actual": null,
                    "expected": null
                },
                {
                    "name": "Training ends with Employment",
                    "actual": null,
                    "expected": null
                },
                {
                    "name": "Participation in Seminars, Workshops and Conferences",
                    "actual": null,
                    "expected": null
                },
                {
                    "name": "Participation in Activities & Events",
                    "actual": null,
                    "expected": null
                },
                {
                    "name": "Others",
                    "actual": null,
                    "expected": null
                }
            ];
            if (this.mode == 'create') {
                this.form = {
                    first_party: {
                        val: null,
                        isValid: true,
                        msg: "",
                    },
                    second_party: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    concerned_department: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    mou_signing_date: {
                        val: null,
                        isValid: true,
                        msg: "",
                    },
                    mou_end_date: {
                        val: null,
                        isValid: true,
                        msg: "",
                    },
                    mou_clauses: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    coordinator_first_party: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    coordinator_second_party: {
                        val: "",
                        isValid: true,
                        msg: "",
                    },
                    mouJointCommitteeMeetings: {
                        val: [],
                        isValid: true,
                        msg: "",
                    },
                    moUOutcomes: {
                        val: dummyMoUOutcomes,
                        isValid: true,
                        msg: "",
                    },
                };
            } else {
                this.form = {
                    first_party: {
                        val: Array.isArray(this.mouEffectivenessCard.first_party_labels) &&
                            this.mouEffectivenessCard.first_party_labels.filter(Boolean).length > 0
                            ? this.mouEffectivenessCard.first_party_labels.filter(Boolean)
                            : null,
                        isValid: true,
                        msg: "",
                    },
                    second_party: {
                        val: this.mouEffectivenessCard.second_party,
                        isValid: true,
                        msg: "",
                    },
                    concerned_department: {
                        val: this.mouEffectivenessCard.concerned_department,
                        isValid: true,
                        msg: "",
                    },
                    mou_signing_date: {
                        val: this.mouEffectivenessCard.mou_signing_date,
                        isValid: true,
                        msg: "",
                    },
                    mou_end_date: {
                        val: this.mouEffectivenessCard.mou_end_date,
                        isValid: true,
                        msg: "",
                    },
                    mou_clauses: {
                        val: this.mouEffectivenessCard.mou_clauses,
                        isValid: true,
                        msg: "",
                    },
                    coordinator_first_party: {
                        val: this.mouEffectivenessCard.coordinator_first_party,
                        isValid: true,
                        msg: "",
                    },
                    coordinator_second_party: {
                        val: this.mouEffectivenessCard.coordinator_second_party,
                        isValid: true,
                        msg: "",
                    },
                    mouJointCommitteeMeetings: {
                        val: Array.isArray(this.mouEffectivenessCard.mouJointCommitteeMeetings)
                            ? this.mouEffectivenessCard.mouJointCommitteeMeetings.map(meeting => ({
                                year: meeting.year || null,
                                q1: meeting.q1 || "",
                                q2: meeting.q2 || "",
                                q3: meeting.q3 || "",
                                q4: meeting.q4 || ""
                            }))
                            : dummyMoUOutcomes,
                        isValid: true,
                        msg: "",
                    },
                    moUOutcomes: {
                        val: Array.isArray(this.mouEffectivenessCard.moUOutcomes)
                            ? this.mouEffectivenessCard.moUOutcomes.map(obj => ({
                                name: obj.name,
                                actual: obj.actual || null,
                                expected: obj.expected || null
                            }))
                            : [],
                        isValid: true,
                        msg: "",
                    },
                };
            }
        },
        addCommitteeMeetingRow() {
            const rows = this.form.mouJointCommitteeMeetings.val;

            const canAddRow =
                rows.length === 0 ||
                rows.every(row => row.year !== null && row.year !== undefined && row.year !== '');

            if (canAddRow) {
                this.form.mouJointCommitteeMeetings.val.push({
                    year: null,
                    q1: null,
                    q2: null,
                    q3: null,
                    q4: null,
                });
            } else {
                alert('Please fill year for all existing rows before adding a new one.');
            }
        },
        handleYearInput(event, item) {
            let raw = event.target.value.replace(/\D/g, ''); // Remove non-digits
            raw = raw.slice(0, 4); // Limit to 4 digits
            item.year = raw ? parseInt(raw, 10) : null; // Convert to integer or null
        },
        getPercentage(x, y) {
            if (!y || isNaN(x) || isNaN(y)) return "";
            return `${parseFloat(((x / y) * 100).toFixed(2))} %`;
        },
        getArabicText(engText) {
            if (engText == 'Graduates Employment') {
                return "توظيف الخريجين";
            } else if (engText == 'Training while studying') {
                return "التدريب أثناء الدراسة";
            } else if (engText == 'Training ends with Employment') {
                return "التدريب بغرض التوظيف";
            } else if (engText == 'Participation in Seminars, Workshops and Conferences') {
                return "المشاركة في الندوات وورش العمل والمؤتمرات";
            } else if (engText == 'Participation in Activities & Events') {
                return "المشاركة في الفعاليات والمناسبات";
            } else if (engText == 'Others') {
                return "أخرى";
            } else {
                return "";
            }
        },
        save() {
            this.$emit('saved', this.form);
        },
    }
}
</script>

<style lang="scss" scoped>
table td {
    height: 40px;
}

.t-heading {
    background-color: #2E5F7F;
}

.t-column {
    background-color: #BDD3EC;
}
</style>